import React from 'react';
import { useTranslation } from 'react-i18next';

interface NavigationTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  className?: string;
  /**
   * When true (tenant Pick'em full navigation enabled), shows the full
   * pre-DKPLAT-347 tab set: Lobby, My Picks, Recent, Leaderboard. Otherwise
   * only My Picks and Leaderboard.
   */
  fullNavigation?: boolean;
}

const NavigationTabs: React.FC<NavigationTabsProps> = ({
  activeTab,
  onTabChange,
  className = '',
  fullNavigation = false,
}) => {
  const { t } = useTranslation();

  const tabs = fullNavigation
    ? [
        { id: 'lobby', label: t('tabs.lobby') },
        { id: 'myPicks', label: t('tabs.myPicks') },
        { id: 'recent', label: t('tabs.recent') },
        { id: 'leaderboard', label: t('tabs.leaderboard') },
      ]
    : [
        { id: 'myPicks', label: t('tabs.myPicks') },
        { id: 'leaderboard', label: t('tabs.leaderboard') },
      ];
  return (
    <div className={`w-full mb-6 ${className}`}>
      <div className="flex items-center border-b border-border/20">
        {tabs.map(tab => (
          <button
            key={tab.id}
            data-test-id={`nav-tab-${tab.id}`}
            onClick={() => onTabChange(tab.id)}
            className={`
              flex-1 py-4 px-4 text-sm font-gilroy font-semibold transition-smooth
              relative whitespace-nowrap
              ${activeTab === tab.id ? 'text-white' : 'text-text-secondary hover:text-text-primary'}
            `}
          >
            {tab.label}
            {/* Green underline for active tab */}
            {activeTab === tab.id && (
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-pickem-primary" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NavigationTabs;
